import React from "react";
import { ToggleSwitch } from "./ToggleSwitch";

export interface SettingRowProps {
  label: string;
  description?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export const SettingRow: React.FC<SettingRowProps> = ({
  label,
  description,
  checked,
  onChange,
}) => {
  return (
    <div className="setting-row">
      <div className="setting-info">
        <div className="setting-label">{label}</div>
        {description && (
          <div className="setting-description">{description}</div>
        )}
      </div>
      <ToggleSwitch checked={checked} onChange={onChange} />
    </div>
  );
};
